import React from 'react';

export type ResponseFilterType = 'all' | 'responded' | 'confirmed' | 'declined' | 'pending';

interface ResponseFilterProps {
  selectedFilter: ResponseFilterType;
  onFilterChange: (filter: ResponseFilterType) => void;
}

const ResponseFilter: React.FC<ResponseFilterProps> = ({
  selectedFilter,
  onFilterChange,
}) => {
  return (
    <section className="filter-section">
      <div className="filter-tabs">
        <button
          className={`filter-tab ${selectedFilter === 'all' ? 'active' : ''}`}
          onClick={() => onFilterChange('all')}
        >
          Tous
        </button>
        <button
          className={`filter-tab ${selectedFilter === 'responded' ? 'active' : ''}`}
          onClick={() => onFilterChange('responded')}
        >
          Ont répondu
        </button>
        <button
          className={`filter-tab ${selectedFilter === 'confirmed' ? 'active' : ''}`}
          onClick={() => onFilterChange('confirmed')}
        >
          Confirmé
        </button>
        <button
          className={`filter-tab ${selectedFilter === 'declined' ? 'active' : ''}`}
          onClick={() => onFilterChange('declined')}
        >
          Refusé
        </button>
        <button
          className={`filter-tab ${selectedFilter === 'pending' ? 'active' : ''}`}
          onClick={() => onFilterChange('pending')}
        >
          En attente
        </button>
      </div>
    </section>
  );
};

export default ResponseFilter;
